import { render } from "./Chat.vue?vue&type=template&id=2cd82746&scoped=true"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=2cd82746&lang=css"
import "./Chat.vue?vue&type=style&index=1&id=2cd82746&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd82746"]])

export default __exports__